import { render, staticRenderFns } from "./StoriesPictures.vue?vue&type=template&id=6798306c&scoped=true"
import script from "./StoriesPictures.vue?vue&type=script&lang=js"
export * from "./StoriesPictures.vue?vue&type=script&lang=js"
import style0 from "./StoriesPictures.vue?vue&type=style&index=0&id=6798306c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6798306c",
  null
  
)

export default component.exports